/**
 * @generated SignedSource<<88595996c300284f85431e20bf01c2db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterCaratWeight_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuCaratWeight_itemSearch">;
  readonly " $fragmentType": "SbMobileRefineMenuFilterCaratWeight_itemSearch";
};
export type SbMobileRefineMenuFilterCaratWeight_itemSearch$key = {
  readonly " $data"?: SbMobileRefineMenuFilterCaratWeight_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbMobileRefineMenuFilterCaratWeight_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterCaratWeight_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a9ee523adaec7ff728b7f74349aed89c";

export default node;
